import { GenericApi } from "./generic.api";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { INotificationData } from '../model/ddb.model';
import { createUrl, queryToParams } from "./api.util";
import { IQueryFilter } from "../model/query.filter.class";
import { filter } from "lodash";

type T = INotificationData;

@Injectable({ providedIn: 'root' })
export class NotificationApi extends GenericApi<T> {
	public path = "notification";

	constructor(public httpClient: HttpClient) {
		super(httpClient);
	}


	readonly markRead = (data: { isRead: boolean, markAll: boolean, id?: string }) => this.httpClient.post<{ success: boolean }>(
		createUrl(this.path, 'update'),
		data
	);
}
